import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LiftingInspectionForm from './components/LiftingInspectionForm';

const NewLiftingInspectionPage: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const assetId = searchParams.get('assetId');

    return (
        <div className="animate-in fade-in duration-500">
            <LiftingInspectionForm
                initialAssetId={assetId || undefined}
                onBack={() => navigate('/assets?tab=lifting')}
                onSaveSuccess={() => navigate('/assets?tab=lifting')}
            />
        </div>
    );
};

export default NewLiftingInspectionPage;
